var News = {
    checkInputs: function() {
        let title = $('#title').val().length;
        let details = $('#details').val().length;
        if (title > 0 && details > 0) {
            return true;
        } else {
            return false;
        }
    },
    addNews: function() {
        this.addPromise()
            .then((response) => {
                //$('#message').html('New post <a href="/news" class="underline">#' + response.data.id + '</a> added');
                window.location.pathname = "/news";
            })
            .catch((error) => {
                console.log(error);
            });
    },
    addPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.title = $('#title').val();
            request.details = $('#details').val();
            request.uid = $('#uid').val();
            window.axios.post('/admin/news/add', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    editNews: function() {
        this.editPromise()
            .then((response) => {
                //$('#message').html('Existing post <a href="/news" class="underline">#' + response.data.id + '</a> edited');
                window.location.pathname = "/news";
            })
            .catch((error) => {
                console.log(error);
            });
    },
    editPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.title = $('#title').val();
            request.details = $('#details').val();
            request.uid = $('#uid').val();
            request.id = $('#id').val();
            window.axios.post('/admin/news/edit', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    }
}

$(document).ready(function() {
    // click add news
    $('#submitNews').on('click', function() {
        // check inputs
        if (!News.checkInputs())
            return;
        News.addNews();
    });
    // click edit news
    $('#editNews').on('click', function() {
        // check inputs
        if (!News.checkInputs())
            return;
        News.editNews();
    });
});